import { getUserRoles } from "./authRoles";
import { hasAnyRole } from "./policy";

function normalizeRoles(value) {
  if (!value) return [];
  if (typeof value === "string") return [value];
  if (Array.isArray(value)) return value;
  if (Array.isArray(value.roles)) return value.roles;
  return [];
}

export function isAllowed(bindingValue) {
  const requiredRoles = normalizeRoles(bindingValue);
  const userRoles = getUserRoles();
  // console.log(userRoles)
  // console.log(requiredRoles)
  // console.log(requiredRoles.length === 0 || hasAnyRole(userRoles, requiredRoles))
  return requiredRoles.length === 0 || hasAnyRole(userRoles, requiredRoles);
}

function setReadonly(el, readonly) {
  el.querySelectorAll("input, textarea, select").forEach(x => {
    if ("readOnly" in x) x.readOnly = readonly;
    if ("disabled" in x) x.disabled = readonly;
  });
}

function setDisabled(el, disabled) {
  el.querySelectorAll("button, input, textarea, select, a").forEach(x => {
    if (x.tagName === "A") {
      x.style.pointerEvents = disabled ? "none" : "";
      x.style.opacity = disabled ? "0.5" : "";
    } else {
      x.disabled = disabled;
    }
  });
}

export function registerSecurityDirectives(app) {

  // 👁️ Hidden
  app.directive("hide", {
    mounted(el, binding) {
      el.style.display = isAllowed(binding.value) ? "" : "none";
    },
    updated(el, binding) {
      el.style.display = isAllowed(binding.value) ? "" : "none";
    }
  });

  // ✏️ Readonly
  app.directive("readonly", {
    mounted(el, binding) {
      setReadonly(el, !isAllowed(binding.value));
    },
    updated(el, binding) {
      setReadonly(el, !isAllowed(binding.value));
    }
  });

  app.directive("disable", {
    mounted(el, binding) {
      setDisabled(el, !isAllowed(binding.value));
    },
    updated(el, binding) {
      setDisabled(el, !isAllowed(binding.value));
    }
  });
}

// Usage: v-hide="[Roles.DEALER_ADMIN, Roles.SUPER_ADMIN]"
// Usage: v-readonly="[Roles.DEALER_ADMIN]"
// Usage: v-disable="[Roles.DEALER_ADMIN]"